import { image } from "@nextui-org/theme";

export const faq = [
  {
    title: "What is the duration of the courses?",
    description:
      "Our Digital Marketing and Web Development courses typically range from 3 to 6 months, depending on the course you choose. We offer flexible learning schedules, including full-time, part-time, and weekend batches to suit your needs.",
  },
  {
    title: "Are the courses suitable for beginners?",
    description:
      "Yes, both our Digital Marketing and Web Development courses are designed for beginners. You don't need prior experience. Our courses start with the fundamentals and progress to advanced topics, ensuring that anyone can follow along.",
  },
  {
    title: "Do I get a certificate upon completing the course?",
    description:
      "Yes! Upon successfully completing your course, you will receive a certification from W3era Academy, which is recognized by top companies in the industry.",
  },
  {
    title: "What are the career opportunities after completing these courses?",
    description:
      "After completing the course, you can pursue various career paths in Digital Marketing (SEO Specialist, Google Ads Expert, Social Media Manager, etc.) or Web Development (Web Developer, Front-end Developer, Full Stack Developer, etc.). We also offer 100% placement assistance to help you land your first job.",
  },
  {
    title: "Will I get hands-on experience during the course?",
    description:
      "We believe in practical learning. Our students work on live projects that are designed to help you gain hands-on experience and build a strong portfolio to showcase to potential employers.",
  },
  {
    title: "What is the cost of the courses?",
    description:
      "The cost varies based on the course you choose. We offer affordable pricing and flexible payment plans. Additionally, we provide scholarships and financial aid for eligible students.",
  },
  {
    title: "Is there any placement assistance after the course?",
    description:
      "Yes, we offer 100% placement assistance to all our students. We partner with top companies and provide career counseling, interview preparation, and job placement support to help you secure a job after graduation.",
  },
  {
    title: "Do you offer online courses, or is it in-person only?",
    description:
      "We offer both online and in-person courses. You can choose the option that best fits your learning preference and location.",
  },
  {
    title: " Can I work while studying?",
    description:
      "Yes, our flexible course schedules are designed to accommodate working professionals. You can choose part-time or weekend batches to balance both work and study.",
  },
  {
    title: " How do I apply for a course?",
    description:
      " Simply click on the “Enroll Now” button on the page, fill in the registration form, and our team will get in touch with you to guide you through the enrollment process.",
  },
]

export const instructor = [
  {
    "id": 6,
    "name": "Vikash Bharia",
    "bio": "Vikash Bharia has over 11 years of experience in Digital Marketing, Google Ads, Social Media Marketing, and more. He has worked with many brands, helping them build their online presence and achieve real results. His strong knowledge and clear way of teaching make him stand out. Whether it’s a basic question or a complex concept for anyone, he resolves it in seconds.\r\nEvery aspirant admires his smart approach, friendly nature, and strong understanding of digital marketing. Students enjoy learning from him and feel inspired under his guidance.",
    "profile_image": "/media/instructors/freepik__background__37090_5.png",
    "experience": null,
    "qualification": null,
    "expertise": "Digital Marketing Specialist",
    "achievements": "",
    "email": null,
    "courses_taught": [
      "Digital Marketing",
      "Google Ads",
      " SEO",
      "Social Media Marketing",
      "Content Marketing"
    ],
    "is_favourite": true,
    "is_publish": true,
    "user_id": 11
  },
  {
    "id": 8,
    "name": "Balwant Solet",
    "bio": "Balwant Solet has over 10 years of experience in front-end development, CMS platforms, and Python web development. He has helped many businesses build user-friendly and efficient websites.\r\nBalwant’s clear and hands-on teaching style makes web development easy to learn. Whether you’re new or experienced, he explains concepts clearly and answers questions quickly.\r\nStudents appreciate his deep technical knowledge and practical approach, which helps them build strong web development skills.",
    "profile_image": "/media/instructors/balvantsir.png",
    "experience": null,
    "qualification": null,
    "expertise": "Web Development Expert",
    "achievements": "",
    "email": null,
    "courses_taught": [
      "Web Development"
    ],
    "is_favourite": true,
    "is_publish": true,
    "user_id": 1
  },
  {
    "id": 9,
    "name": "Vijay Kumar",
    "bio": "Vijay Kumar has over 5 years of experience in Python and Django web development. He is skilled in building efficient, scalable web applications and has worked on many projects with diverse clients.\r\n\r\nApart from Python and Django, Vijay also teaches related web development skills such as REST APIs, database management, and basic front-end technologies. His clear and patient teaching style helps students understand complex programming concepts easily.\r\n\r\nStudents appreciate his practical approach and real-world examples, which make learning web development engaging and effective.",
    "profile_image": "/media/instructors/DSC_1801_2.png",
    "experience": null,
    "qualification": null,
    "expertise": "Web Development Specialist",
    "achievements": "",
    "email": null,
    "courses_taught": [
      "Web Development"
    ],
    "is_favourite": true,
    "is_publish": true,
    "user_id": 15
  }
];
export const courses = [
  {
    title: "HTML/CSS/Bootstrap/JS/CMS",
    subtitle: "WordPress & Shopify",
    description:
      "Learn the basics of front-end design and how to use popular CMS platforms for website management.",
    duration: "90 Days",
    image: "/images/offline/01.webp"
  },
  {
    title: "HTML/CSS/Bootstrap/JS/PHP",
    subtitle: "Full Stack Development",
    description:
      "Master the essential front-end and back-end technologies for building scalable websites.",
    duration: "90 Days",
    image:
      "/images/offline/02.webp"
  },
  {
    title: "HTML/CSS/Bootstrap/JS/Python",
    subtitle: "Python Web Development",
    description: "Build dynamic websites and integrate advanced features using Python.",
    duration: "90 Days",
    image:
      "/images/offline/03.webp"
  },
  {
    title: "HTML/CSS/Bootstrap/JS/Django",
    subtitle: "Django Framework",
    description: "Learn web development with Django framework and integrate it into your websites.",
    duration: "90 Days",
    image:
      "/images/offline/04.webp"
  },
  {
    title: "HTML/CSS/Bootstrap/JS/ReactJs/NextJs",
    subtitle: "Modern Frontend Development",
    description:
      "Learn modern web development using ReactJS and NextJS for building powerful front-end applications.",
    duration: "90 Days",
    image:
      "/images/offline/05.webp"
  },
]


export const faq_digital = [
  {
    title: "What is the duration of the Digital Marketing course?",
    description: "Our Digital Marketing course lasts for 3-6 months, with flexible learning options.",
  },
  {
    title: "Can I take this course if I have no prior experience?",
    description: "Yes, this course is designed for both beginners and experienced professionals.",
  },
  {
    title: "Will I get a certificate after completing the course?",
    description:
      "Yes, you will receive a W3era Academy certification upon successful completion of the course.",
  },
  {
    title: "Do you provide job placement assistance?",
    description:
      "Yes, we provide 100% placement assistance to help you land a job after course completion.",
  },
  {
    title: "What's included in the course fee?",
    description:
      "The course fee covers all training materials, live project work, certification, and placement assistance.",
  },
]

export const choose_digital =
  [
    {
      icon: "/images/offline/icons/icon1.svg",
      title: "100% Placement Assistance",
      description:
        "Connect with top companies in digital marketing and web development, with a chance to work at W3era.",
    },
    {
      icon: "/images/offline/icons/icon2.svg",
      title: "Industry-Expert Trainers",
      description: "Learn from professionals with over 10 years of real-world experience.",
    },
    {
      icon: "/images/offline/icons/icon3.svg",
      title: "Hands-on Live Projects",
      description: "Gain practical experience by working on 1,500+ live projects to build your portfolio.",
    },
    {
      icon: "/images/offline/icons/icon4.svg",
      title: "Flexible Learning Options",
      description: "Choose from part-time, full-time, and weekend batches to fit your schedule.",
    },
    {
      icon: "/images/offline/icons/icon5.svg",
      title: "Lifetime Access",
      description:
        "Get lifetime access to course materials and updates, keeping you ahead of industry trends.",
    },
    {
      icon: "/images/offline/icons/icon6.svg",
      title: "Scholarship Program",
      description: "Eligible candidates can receive a 100% fee waiver upon successful course completion.",
    },
    {
      icon: "/images/offline/icons/icon7.svg",
      title: "Free Access to W3era Tools",
      description: "Get lifetime access to our proprietary digital marketing tools to enhance your learning.",
    },
    {
      icon: "/images/offline/icons/icon8.svg",
      title: "500+ Students Trained",
      description: "Join over 500 successful graduates now working at top companies worldwide.",
    },
    {
      icon: "/images/offline/icons/icon9.svg",
      title: "50+ Industry Partnerships",
      description: "Real-time internships and job placements with leading companies in the industry.",
    },]


export const faqs_development = [
  {
    title: "What is the duration of the Website Development course?",
    description:
      "The Website Development course takes 4-6 months to complete, depending on the mode and schedule you choose.",
  },
  {
    title: "Do I need any prior experience to take this course?",
    description: "No, this course is designed for beginners. We cover everything from the basics to advanced concepts.",
  },
  {
    title: "Will I get a certificate after completing the course?",
    description: "Yes, you will receive a W3era Academy Website Development Certification upon completing the course.",
  },
  {
    title: "Do you offer job placement assistance?",
    description:
      "Yes, we offer 100% placement assistance. Our dedicated placement team helps you secure your first job in web development.",
  },
  {
    title: "What technologies will I learn in this course?",
    description:
      "You will learn HTML, CSS, JavaScript, PHP, Python, ReactJS, Django, and WordPress, among other essential web development technologies.",
  },
]



